import I18n from '@app/adapters/I18n'
import type {
  TemplatePreparation,
  TemplateReview,
} from '@app/application/workflows/types'
import {
  formatPreparationUser,
  formatReviewUsersList,
} from '@app/application/workflows/utils/format-preparation-and-review'
import getReviewState from '@app/insights/utils/get-review-state'

export const formatPreparation = (
  preparation: TemplatePreparation | null,
  inline?: boolean
): string => {
  if (!preparation) {
    return I18n.t('reconciliation_preparation.not_marked_as_prepared')
  }
  const prefix = I18n.t('reconciliation_preparation.prepared_by')
  const separator = inline ? ' ' : '<br />'
  const user = formatPreparationUser(preparation)

  return `${prefix}${separator}${user}`
}

export const formatReviews = (
  reviews: TemplateReview[] | null,
  inline?: boolean
): string => {
  const { hasReviews, prefix } = getReviewState(reviews)

  if (!hasReviews) {
    return I18n.t('reconciliation_review.not_marked_as_reviewed')
  }

  const reviewersList = formatReviewUsersList(reviews!, inline)
  const separator = inline ? ' ' : '<br />'

  return `${prefix}${separator}${reviewersList}`
}
